import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../http_client";

import {
  faqArticleFetchError,
  faqArticleFetchRequest,
  faqArticleFetchSuccess,
  faqCategoriesFetchError,
  faqCategoriesFetchSuccess,
} from "./actions";
import { FAQActionTypes } from "./types";

export function* handleCategoriesFetch(): SagaIterator {
  try {
    const response = yield call(callGet, "/faq/categories/");
    yield put(faqCategoriesFetchSuccess({ items: response.data }));
  } catch (err) {
    yield put(faqCategoriesFetchError(err.message));
  }
}

export function* handleArticleFetch(action: ReturnType<typeof faqArticleFetchRequest>): SagaIterator {
  try {
    const { slug } = action.payload;
    const response = yield call(callGet, `/faq/articles/${slug}/`);
    yield put(faqArticleFetchSuccess(response.data));
  } catch (err) {
    yield put(faqArticleFetchError(err.message));
  }
}

function* watchFAQSagas(): SagaIterator {
  yield takeLatest(FAQActionTypes.ARTICLE_FETCH_REQUEST, handleArticleFetch);
  yield takeLatest(FAQActionTypes.CATEGORIES_FETCH_REQUEST, handleCategoriesFetch);
}

export default watchFAQSagas;
